import * as React from 'react';
import { Navigate } from 'react-router-dom';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import TreeView from '@mui/lab/TreeView';
import TreeItem, { TreeItemProps } from '@mui/lab/TreeItem';
import ImageIcon from '@mui/icons-material/Image';
import { Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import './Tree.css';

interface ITreeProps {}

type MyTreeItemProps = {
    idobjs?: any;
    treeobj?: any;
    onClickRow?: any;
};

function MyTreeItem(props: MyTreeItemProps) {
    let { idobjs, treeobj, onClickRow } = props;

    let listItems = idobjs?.map((ids: any) => {
        if (treeobj[ids].type == 'item' || treeobj[ids].type == 'itemsystem') {
            let children = undefined;

            if (treeobj[ids]['children']?.length > 0) {
                children = MyTreeItem({ idobjs: treeobj[ids]['children'], treeobj: treeobj, onClickRow: onClickRow });
            } else if (treeobj[ids].childscount > 0) {
                children = <CircularProgress />;
            }

            return (
                <TreeItem
                    key={ids}
                    onClick={(ev: any) => {
                        onClickRow(ids);
                        window.dispatchEvent(
                            new CustomEvent('EventSelectedMenuItem', {
                                detail: { id: ids, name: treeobj[ids].name }
                            })
                        );
                    }}
                    nodeId={ids}
                    label={
                        <div className="MyDiv">
                            <svg style={{ float: 'left' }} viewBox="0 0 24 24" className="MuiSvgIcon-root">
                                <path
                                    _ngcontent-qnw-c1=""
                                    d="M18.5 19.0H3.5C2.8 19.0 2.2 18.7 1.7 18.3C1.2 17.8 1.0 17.2 1 16.5V4.4C1.0 3.7 1.2 3.1 1.7 2.6C2.2 2.2 2.8 1.9 3.5 2.0H8.1C8.2 2.0 8.3 2.0 8.5 2.0C8.6 2.1 8.7 2.2 8.8 2.3L11.4 5.5H18.4C18.7 5.5 19.1 5.5 19.4 5.7C19.7 5.8 20.0 6.0 20.2 6.2C20.4 6.4 20.6 6.7 20.7 7.0C20.9 7.3 20.9 7.6 21 7.9V16.5C20.9 17.2 20.7 17.8 20.2 18.3C19.7 18.7 19.1 19.0 18.5 19.0ZM3 12.2V16.5C3.0 16.6 3.0 16.6 3.0 16.7C3.0 16.8 3.1 16.8 3.1 16.8C3.2 16.9 3.2 16.9 3.3 16.9C3.3 16.9 3.4 17.0 3.5 17.0H18.5C18.5 17.0 18.6 16.9 18.6 16.9C18.7 16.9 18.7 16.9 18.8 16.8C18.8 16.8 18.9 16.8 18.9 16.7C18.9 16.6 18.9 16.6 19 16.5V7.9C18.9 7.9 18.9 7.8 18.9 7.8C18.9 7.7 18.8 7.6 18.8 7.6C18.7 7.6 18.7 7.5 18.6 7.5C18.6 7.5 18.5 7.5 18.5 7.5H11C10.8 7.5 10.7 7.5 10.5 7.4C10.4 7.3 10.3 7.2 10.2 7.1L7.6 4.0H3.5C3.4 3.9 3.3 4.0 3.3 4.0C3.2 4.0 3.2 4.0 3.1 4.1C3.1 4.1 3.0 4.1 3.0 4.2C3.0 4.3 3.0 4.3 3 4.4V12.2Z"></path>
                            </svg>
                            <Typography>{treeobj[ids].name}</Typography>
                        </div>
                    }
                    children={children}
                />
            );
        } else {
            return (
                <TreeItem
                    key={ids}
                    onClick={(ev: any) => {
                        window.OpenMnemo(treeobj[ids].file);
                        console.debug(ids);
                    }}
                    nodeId={ids}
                    label={
                        <div>
                            <ImageIcon style={{ float: 'left' }} />
                            <Typography>{treeobj[ids].name}</Typography>
                        </div>
                    }
                />
            );
        }
    });

    return <div>{listItems}</div>;
}

const Tree = (props: ITreeProps) => {
    const [tree, setTree] = React.useState<any>({});
    const [treeRootid, setTreeRootid] = React.useState('');
    const [treesettings, setTreeSettings] = React.useState<any>({});

    const [defaultmessage, setdefaultmessage] = React.useState(' Загрузка...');

    React.useEffect(() => {
        let setTime = setTimeout(() => {
            LoadTree();
        }, 200);
        //LoadTree();
        return function clear() {};
    }, []);

    React.useEffect(() => {
        if (treeRootid != '') LoadUDPobjecttree(treeRootid);

        return function clear() {};
    }, [treeRootid]);

    let LoadTree = function () {
        fetch(`/ixyber/vision/file/LokTree`)
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.json();
            })
            .then((data: any) => {
                setTreeSettings(JSON.parse(data));
                LoadUDPtree();
            })
            .catch((error: any) => {
                console.log('error', error);
                return {};
            });
    };

    let LoadUDPtree = function () {
        fetch(`/hierarchy-adapter/restapi/models`)
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.json();
            })
            .then((data: any) => {
                let temptree = JSON.parse(JSON.stringify(tree));

                let idobj = data.content[0].id;
                let name = data.content[0].name;

                temptree[idobj] = {
                    id: idobj,
                    name: name,
                    children: []
                };
                temptree[idobj].type = 'item';

                setTree(temptree);
                setTreeRootid(idobj);
            })
            .catch((error: any) => {
                console.log('error', error);
                setdefaultmessage('error');
            });
    };

    let sortContent = function (a: any, b: any) {
        if (a.name > b.name) {
            return 1;
        }
        if (a.name < b.name) {
            return -1;
        }
        return 0;
    };

    let LoadUDPobjecttree = function (modelid: string, inchild: boolean = true) {
        if (tree[modelid]['children'].length < 1) {
            fetch('/hierarchy-adapter/restapi/models/' + modelid + '/objects?isNeedChildrenCount=true')
                .then((response) => {
                    if (!response.ok) throw Error(response.statusText);
                    return response.json();
                })
                .then(async (data: any) => {
                    let temptree = JSON.parse(JSON.stringify(tree));

                    temptree[modelid]['children'] = [];

                    data.content = data.content.sort(sortContent);

                    if (treesettings[modelid] != null) {
                        let idobjmnemo = modelid + 'mnemofolder';

                        temptree[modelid]['children'].push(idobjmnemo);

                        temptree[idobjmnemo] = {
                            id: idobjmnemo,
                            name: 'Мнемосхемы',
                            children: []
                        };
                        temptree[idobjmnemo].type = 'itemsystem';

                        for (let ind in treesettings[modelid].mnemo) {
                            let idobj = idobjmnemo + treesettings[modelid].mnemo[ind].name;

                            temptree[idobjmnemo]['children'].push(idobj);

                            temptree[idobj] = treesettings[modelid].mnemo[ind];
                            temptree[idobj].type = 'mnemo';
                            temptree[idobj]['children'] = [];
                        }
                    }

                    for (let ind in data.content) {
                        let idobj = data.content[ind].id;

                        temptree[modelid]['children'].push(idobj);

                        temptree[idobj] = data.content[ind];
                        temptree[idobj].type = 'item';
                        temptree[idobj]['children'] = [];
                    }

                    setTree(temptree);
                })
                .catch((error: any) => {
                    console.log('error', error);
                    setdefaultmessage('error');
                });
        }
    };

    let onClickRow = function (modelid: any) {
        LoadUDPobjecttree(modelid);
    };

    if (treeRootid != '') {
        return (
            <TreeView
                defaultExpanded={['1']}
                defaultCollapseIcon={
                    <svg
                        style={{ marginTop: '5px' }}
                        className="MuiSvgIcon-root"
                        viewBox="0 0 30 30"
                        transform="rotate(90)">
                        <path
                            _ngcontent-qnw-c1=""
                            d="M8.1 17.9C7.8 17.9 7.6 17.9 7.4 17.7C7.2 17.6 7.2 17.5 7.1 17.4C7.0 17.3 7.0 17.2 7.0 17.0C6.9 16.9 7.0 16.8 7.0 16.7C7.0 16.5 7.1 16.4 7.2 16.3L12.3 11.0L7.4 5.6C7.3 5.5 7.2 5.4 7.2 5.3C7.1 5.1 7.1 5.0 7.1 4.9C7.2 4.7 7.2 4.6 7.3 4.5C7.4 4.4 7.4 4.3 7.6 4.2C7.7 4.1 7.8 4.0 8.0 4.0C8.1 4.0 8.3 3.9 8.4 4.0C8.6 4.0 8.7 4.0 8.9 4.1C9.0 4.1 9.1 4.2 9.2 4.3L14.7 10.3C14.9 10.5 15 10.7 15 11.0C15 11.2 14.9 11.4 14.7 11.6L9.0 17.6C8.9 17.7 8.8 17.8 8.6 17.9C8.4 17.9 8.3 18.0 8.1 17.9Z"></path>
                    </svg>
                }
                defaultExpandIcon={
                    <svg style={{ marginTop: '5px' }} className="MuiSvgIcon-root" viewBox="0 0 15 30">
                        <path
                            _ngcontent-qnw-c1=""
                            d="M8.1 17.9C7.8 17.9 7.6 17.9 7.4 17.7C7.2 17.6 7.2 17.5 7.1 17.4C7.0 17.3 7.0 17.2 7.0 17.0C6.9 16.9 7.0 16.8 7.0 16.7C7.0 16.5 7.1 16.4 7.2 16.3L12.3 11.0L7.4 5.6C7.3 5.5 7.2 5.4 7.2 5.3C7.1 5.1 7.1 5.0 7.1 4.9C7.2 4.7 7.2 4.6 7.3 4.5C7.4 4.4 7.4 4.3 7.6 4.2C7.7 4.1 7.8 4.0 8.0 4.0C8.1 4.0 8.3 3.9 8.4 4.0C8.6 4.0 8.7 4.0 8.9 4.1C9.0 4.1 9.1 4.2 9.2 4.3L14.7 10.3C14.9 10.5 15 10.7 15 11.0C15 11.2 14.9 11.4 14.7 11.6L9.0 17.6C8.9 17.7 8.8 17.8 8.6 17.9C8.4 17.9 8.3 18.0 8.1 17.9Z"></path>
                    </svg>
                }
                /*
                defaultCollapseIcon={<ArrowDropDownIcon />}
                defaultExpandIcon={<ArrowRightIcon />}
                */
            >
                <MyTreeItem treeobj={tree} idobjs={[treeRootid]} onClickRow={onClickRow} />
            </TreeView>
        );
    } else {
        return <div>{defaultmessage}</div>;
    }
};

export default Tree;
